var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{style:({backgroundColor:_vm.color}),attrs:{"id":"empty-img"}},[_c('img',{attrs:{"src":require("../../static/images/empty/pg_wushuju@2x.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("暂无数据")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7418fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emptyList.vue
// module id = null
// module chunks = 